module.exports = __webpack_public_path__ + "img/Asset_rule_Web_Text1.2e150097.png";